import { render, staticRenderFns } from "./minMaxInput.vue?vue&type=template&id=1377504a&scoped=true"
import script from "./minMaxInput.vue?vue&type=script&lang=js"
export * from "./minMaxInput.vue?vue&type=script&lang=js"
import style0 from "./minMaxInput.vue?vue&type=style&index=0&id=1377504a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377504a",
  null
  
)

export default component.exports